/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { InjectionToken } from '@angular/core';
export const /** @type {?} */ MAT_DATE_FORMATS = new InjectionToken('mat-date-formats');
//# sourceMappingURL=date-formats.js.map